import { Loader } from "lucide-react";
import { FC } from "react";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useDeleteTrackMutation } from "@/data/mutations";
import { Track } from "@/data/types";
import { useDialogState } from "@/hooks/use-dialog-state";

export const DeleteTrackDialog: FC<Track> = (track) => {
  const { dialog, closeDialog } = useDialogState();
  const deleteTrackMutation = useDeleteTrackMutation();

  const handleSubmit = () => {
    deleteTrackMutation.mutate(track.id);
  };

  return (
    <AlertDialog open={dialog?.name === "delete-track"}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Track {track.file_name}</AlertDialogTitle>
          <AlertDialogDescription>
            Track {track.file_name} will be deleted. This action is
            irreversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={closeDialog}
            disabled={deleteTrackMutation.isPending}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleSubmit}
            disabled={deleteTrackMutation.isPending}
          >
            {deleteTrackMutation.isPending && (
              <Loader className="animate-spin" />
            )}
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
